<template>
  <datepicker :value="inputvalue" v-model="inputvalue" :name="name"
              :clear-button="clearbutton" :required="required" :language="language"
              :disabled="disabled" :format="customFormatter"
              full-month-name monday-first :minimum-view="views.min||'day'"
              :maximum-view="views.max||'year'" :initial-view="views.init||views.min||'day'"
              @input="handleInput" placeholder="JJ/MM/AAAA" ></datepicker>
</template>

<style>
  .vdp-datepicker input {
    width: 98%;
    border: 0 solid #000;
  }
</style>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale/index.js'

export default {
  name: 'inputDate',
  components: { Datepicker },
  props: ['name', 'value', 'required', 'clearbutton', 'disabled', 'minView', 'maxView', 'initView', 'format'],
  data () {
    return {
      inputvalue: null,
      language: lang.fr,
      views: { min: this.minView, max: this.maxView, init: this.initView },
      dateFormat: this.format || 'DD/MM/YYYY'
    }
  },
  created() {
    this.inputvalue = this.value ? moment(this.value, this.dateFormat).toDate() : new Date()
  },
  watch: {
    value: function(newVal, oldVal) { // used when dynamicly change date from outside component
      this.inputvalue = newVal ? moment(newVal, this.dateFormat, true).toDate() : newVal
    },
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.customFormatter(this.inputvalue))
    },
    customFormatter (date) {
      return moment(date).format(this.dateFormat)
    }
  }
}
</script>
